/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactInfo } from './ContactInfo';
import {
    ContactInfoFromJSON,
    ContactInfoFromJSONTyped,
    ContactInfoToJSON,
} from './ContactInfo';

/**
 * 
 * @export
 * @interface BrokerInfo
 */
export interface BrokerInfo {
    /**
     * 
     * @type {string}
     * @memberof BrokerInfo
     */
    name: string | null;
    /**
     * 
     * @type {ContactInfo}
     * @memberof BrokerInfo
     */
    contactInformation: ContactInfo | null;
}

/**
 * Check if a given object implements the BrokerInfo interface.
 */
export function instanceOfBrokerInfo(value: object): value is BrokerInfo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('contactInformation' in value) || value['contactInformation'] === undefined) return false;
    return true;
}

export function BrokerInfoFromJSON(json: any): BrokerInfo {
    return BrokerInfoFromJSONTyped(json, false);
}

export function BrokerInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'contactInformation': ContactInfoFromJSON(json['contactInformation']),
    };
}

export function BrokerInfoToJSON(value?: BrokerInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'contactInformation': ContactInfoToJSON(value['contactInformation']),
    };
}

